// import "../../styling/style.css";
import { Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Formik, FormikErrors } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import AutocompleteComponent from "../../components/autocomplete/autocomplete-mui";
import CommentDisabledComponent from "../../components/commentdisabled/textfield-disabled-mui";
import CRRNumberField from "../../components/crrnumberfield/crr-number-field-mui";
import ConfirmationDialog from "../../components/dialog/simple-alert";
import DropdownlistComponent from "../../components/dropdownlist/dropdownlist-mui";
import DropdownlistComponentValidation from "../../components/dropdownlistvalidation/dropdownlist-validation-mui";
import Feedback from "../../components/feedback/feedback";
import FeedbackNotification from "../../components/feedbacknotification/feedback-notification";
import Loading from "../../components/loading/loading";
import TextFieldComponent from "../../components/textfield/textfield-mui";
import TextFieldDateComponent from "../../components/textfielddate/textfield-date-mui";
import TextFieldDateValidationComponent from "../../components/textfielddatevalidation/textfield-date-validation-mui";
import TextFieldDisabledComponent from "../../components/textfielddisabled/textfield-disabled-mui";
import TextFieldMultiComponent from "../../components/textfieldmulti/textfield-multi-mui";
import TextFieldMultiDisabledComponent from "../../components/textfieldmultidisabled/textfield-multi-disabled-mui";
import UploadMultipleFileComponent from "../../components/uploadmultiplefile/UploadMultipleFile";
import { IDataComment } from "../../interfaces/IDataComment";
import { NewIDataUploadItem } from "../../interfaces/IDataUploadItem";
import { IForm } from "../../interfaces/IForm";
import { TransactionHistoryModal } from "../../shared/Components/TransactionHistoryModal";
import { DocumentType, RequestStatus, RequestType } from "../../shared/Enum";
import {
  FilterDistinctByIdAndSort,
  RemoveDateFromFileName,
} from "../../shared/functions";
import {
  selectNewProfile,
  selectNewProfileRole,
} from "../../store/newProfile/selector";
import { homeStyle } from "../../styles/container/home";
import {
  downloadFileComment,
  downloadSingleFile,
  editForm,
  getListAreaLocation,
  getListDocumentType,
  getListRequestType,
  getListUnderLevelStaff,
  getSharepointToken,
  getSingleDataRequest,
} from "./api-endpoint/callApi";

const getBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    reader.addEventListener("error", (error) => {
      reject(error);
    });
    reader.readAsDataURL(file);
  });

function EditForm() {
  const { id } = useParams();
  const [listDocumentType, setListDocumentType] = useState([]);
  const [listAreaLocation, setListAreaLocation] = useState([]);
  const [listRequestType, setListRequestType] = useState([]);
  const [validationDocumentType, setValidationDocumentType] = useState(
    DocumentType.toId(DocumentType.Softcopy)
  );
  const [validationRequestType, setValidationRequestType] = useState(
    RequestType.toId(RequestType.SuratKuasa)
  );
  const [validationDateOfPower, setValidationDateOfPower] = useState("");
  const [sharepoint, setSharepoint] = useState<any>({ token: "", expToken: 0 });
  const [errorUpload, setErrorUpload] = useState("");
  const [openFeedbackNotification, setOpenFeedbackNotification] =
    useState(false);
  const [requestStatusName, setRequestStatusName] = useState("");

  const [crrNumber, setCrrNumber] = useState("");
  const [crrNumError, setCrrError] = useState("");
  const [formData, setFormData] = useState<IForm | undefined>();
  const [actionClick, setActionClick] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [loadingActive, setLoadingActive] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [openFeedback, setOpenFeedback] = useState(false);
  const [requestNumber, setRequestNumber] = useState("");
  const [requestDate, setRequestDate] = useState("");
  const [requestStatusID, setRequestStatusID] = useState("");
  const [userRevision, setUserRevision] = useState(0);
  const [dataUpload, setDataUpload] = useState<NewIDataUploadItem[]>([
    {
      title: "Unggah Draft Final / Upload Final Draft*",
      fileType: "Draft Final",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);

  const [dataComment, setDataComment] = useState<IDataComment[]>([]);

  const [valueTab, setValueTab] = useState(0);
  const getRole = useSelector(selectNewProfileRole);
  const profile = useSelector(selectNewProfile);
  const today = new Date();
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const reqDate = `${today.getDate()} ${
    month[today.getMonth()]
  } ${today.getFullYear()}`;
  const Navigate = useNavigate();

  const [initialValues, setInitialValues] = useState<IForm>({
    startDatePeriod: "",
    endDatePeriod: "",
    binusianID: profile.BinusianId,
    email: "",
    binusianName: "",
    businessUnit: "",
    department: "",
    title: "",
    buLeader: "",
    extension: "",
    documentType: DocumentType.toId(DocumentType.Softcopy),
    requestType: RequestType.toId(RequestType.SuratKuasa),
    dateOfPower: "",
    dateGrantOfPower: "",
    clNote: "",
    lrNote: "",
    signer: { name: "Tidak ada", binusianIDEmail: "Tidak ada~Tidak ada" },
    titleAgreement: "",
    area: "Anggrek",
    address: "",
    counterPart: "",
    requestDate: reqDate,
    substitutor: null,
    delegatee: null,
    noPowerAttorney: "",
    noSubstitutor: "",
  });

  const getRequestType = async () => {
    try {
      // get all data for table list User
      const msRequestType = await getListRequestType();
      setListRequestType(msRequestType);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  const getDocumentType = async () => {
    try {
      // get all data for table list User
      const ltDocumentType = await getListDocumentType();
      setListDocumentType(ltDocumentType);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  const getAreaLocation = async () => {
    try {
      // get all data for table list User
      const tempDataAreaLocation: any = [];
      const ltAreaLocation = await getListAreaLocation();
      const jsonParse = JSON.parse(ltAreaLocation);
      jsonParse.data.forEach((datas: any) => {
        tempDataAreaLocation.push({
          label: datas.locationHierarcy.text,
          value: datas.locationHierarcy.id,
        });
      });
      const distinctLocation = FilterDistinctByIdAndSort(tempDataAreaLocation);
      setListAreaLocation(distinctLocation);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };
  /* eslint-disable unicorn/consistent-function-scoping */
  function transformData(data): any[] {
    const categoryMap = {
      "Draft Final": "Unggah Draft Final / Upload Final Draft*",
      "Approval BU Leader": "Approval BU Leader / BU Leader Approval*",
      "Partner Request": "Unggah Permohonan Partner / Upload Partner Request",
    };
    const categoryKey = {
      "Draft Final": 1,
      "Approval BU Leader": 2,
      "Partner Request": 3,
    };
    const orderedCategoryKeys = Object.keys(categoryKey).sort(
      (a, b) => categoryKey[a] - categoryKey[b]
    );

    const groupedData = data.reduce((acc, item) => {
      const { category, documentID, documentName, link } = item;
      const newTitleName = categoryMap[category] || category;
      const newCategory = categoryKey[category]
        ? category
        : categoryKey[category];
      acc[newCategory] = acc[newCategory] || {
        title: newTitleName,
        fileType: category,
        files: [],
      };
      acc[newCategory].files.push({
        documentID,
        fileBase64: "",
        fileName: documentName,
        folderName: link,
      });
      return acc;
    }, {});

    return orderedCategoryKeys
      .map((key) => groupedData[key])
      .filter((item) => item !== undefined);
  }
  /* eslint-enable unicorn/consistent-function-scoping */

  // eslint-disable-next-line consistent-return
  const getSingleData = async () => {
    try {
      const getSingleRequest = await getSingleDataRequest(id);
      setRequestStatusName(getSingleRequest.trRequest.requestStatusName);

      // Modified CRR handling
      const dbCRR = getSingleRequest.trRequest.noCRR;
      setCrrNumber(dbCRR);

      // mencari level staff dibawahnya
      const getUnderLevelStaff = await getListUnderLevelStaff(
        profile.BinusianId
      );

      // Validation Access Page
      if (
        (getSingleRequest.trRequest.binusianID == profile.BinusianId ||
          getRole.roleId == "RL230000001" ||
          getUnderLevelStaff.includes(getSingleRequest.trRequest.binusianID)) &&
        (getSingleRequest.trRequest.requestStatusID ==
          RequestStatus.toId(RequestStatus.Draft) ||
          getSingleRequest.trRequest.requestStatusID ==
            RequestStatus.toId(RequestStatus.Pending))
      ) {
        Navigate("");
      } else {
        Navigate("/");
      }

      if (
        getSingleRequest.trRequest.requestStatusID ==
          RequestStatus.toId(RequestStatus.Pending) &&
        getSingleRequest.trRequest.userRevision > 0
      ) {
        Navigate(`/view/${id}`);
      }

      // profile
      initialValues.binusianName = getSingleRequest.trRequest.binusianName;
      initialValues.businessUnit = getSingleRequest.trRequest.businessUnit;
      initialValues.department = getSingleRequest.trRequest.department;
      initialValues.title = getSingleRequest.trRequest.title;
      initialValues.buLeader = getSingleRequest.trRequest.buLeader;
      initialValues.extension = getSingleRequest.trRequest.ext;

      setRequestNumber(getSingleRequest.trRequest.requestNumber);
      setRequestDate(
        moment(getSingleRequest.trRequest.requestDate).format("DD MMMM YYYY")
      );
      setRequestStatusID(getSingleRequest.trRequest.requestStatusID);
      // case Soft Copy
      initialValues.dateOfPower = moment(
        getSingleRequest.trRequest.poaDate
      ).format("YYYY-MM-DD");
      initialValues.signer = {
        binusianIDEmail: getSingleRequest.trRequest.signer.split("#")[0],
        name: getSingleRequest.trRequest.signer.split("#")[1],
      };
      initialValues.titleAgreement = getSingleRequest.trRequest.titleAgreement;
      initialValues.counterPart = getSingleRequest.trRequest.counterpart;
      initialValues.documentType = getSingleRequest.trRequest.documentTypeID;
      initialValues.requestType = getSingleRequest.trRequest.requestTypeID;
      if (getSingleRequest.trRequest.startMasterUsePeriod !== null) {
        initialValues.startDatePeriod = moment(
          getSingleRequest.trRequest.startMasterUsePeriod
        ).format("YYYY-MM-DD");
        initialValues.endDatePeriod = moment(
          getSingleRequest.trRequest.endMasterUsePeriod
        ).format("YYYY-MM-DD");
      }

      setValidationDocumentType(getSingleRequest.trRequest.documentTypeID);
      // case Hard Copy
      if (
        getSingleRequest.trRequest.documentTypeID ==
        DocumentType.toId(DocumentType.Hardcopy)
      ) {
        initialValues.area = getSingleRequest.trRequest.area;
        initialValues.address = getSingleRequest.trRequest.detailArea;
      }

      const filteredJustMultiUpload = getSingleRequest.trDocument.filter(
        (item) =>
          item.category !== "Hardcopy SK" &&
          item.category !== "Master Document Realization"
      );
      const transformedData = transformData(filteredJustMultiUpload);
      if (transformedData.length == 2) {
        const newItem: NewIDataUploadItem = {
          title: "Unggah Permohonan Partner / Upload Partner Request",
          fileType: "Partner Request",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        };
        transformedData.push(newItem);
      }
      if (transformedData.length === 0) {
        const newItem: NewIDataUploadItem = {
          title: "Unggah Draft Final / Upload Final Draft*",
          fileType: "Draft Final",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        };
        transformedData.push(newItem);
        handleChangeDateOfPower(getSingleRequest.trRequest.poaDate);
      }

      setDataUpload(transformedData);

      if (getSingleRequest.trComment.length > 0) {
        const filteredData = getSingleRequest.trComment.filter(
          (item) => item.toRole === "RL230000002"
        );
        setDataComment(filteredData);
      }
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //   getDocumentType();
  //   getAreaLocation();
  //   console.log("id url:", id);
  //   if (id !== undefined) {
  //     // get api data
  //     getSingleData();
  //     setValueTab(1);
  //   }
  // }, []);

  useEffect(() => {
    const firstLoad = async () => {
      setLoadingActive(true);
      await getDocumentType();
      await getAreaLocation();
      await getRequestType();
      if (id !== undefined) {
        // get api data
        await getSingleData();
        setValueTab(1);
      }
      setLoadingActive(false);
    };
    firstLoad();
  }, []);

  const validation = (values: IForm) => {
    const errors: FormikErrors<IForm | undefined> = {};
    if (values.dateOfPower === "") {
      errors.dateOfPower = "Date of Power of Attorney must be filled";
    }
    if (
      values.requestType == RequestType.toId(RequestType.DokumenMaster) &&
      values.startDatePeriod == ""
    ) {
      errors.startDatePeriod = "Period of Use must be filled";
    }
    if (values.startDatePeriod !== "" && values.endDatePeriod === "") {
      errors.endDatePeriod = "End Date Period must be filled";
    }
    if (values.startDatePeriod === "" && values.endDatePeriod !== "") {
      errors.startDatePeriod = "Start Date Period must be filled";
    }
    if (
      values.startDatePeriod !== "" &&
      values.endDatePeriod !== "" &&
      values.endDatePeriod < values.startDatePeriod
    ) {
      errors.endDatePeriod = "End Date must not be earlier than Start Date";
    }
    if (values.titleAgreement === "") {
      errors.titleAgreement = "Title of Agreement must be filled";
    }
    if (
      values.address === "" &&
      values.documentType == DocumentType.toId(DocumentType.Hardcopy)
    ) {
      errors.address = "Address must be filled";
    }
    if (values.counterPart === "") {
      errors.counterPart = "Counterpart must be filled";
    }
    if (values.signer === null) {
      errors.signer = "Signer must be filled";
    }

    const checkFileRequired = dataUpload.some(
      (item) =>
        item.title.includes("*") &&
        item.files.some((file) => file.fileName === "")
    );
    if (checkFileRequired) {
      setErrorUpload("Please upload required file");
    } else {
      setErrorUpload("");
    }

    if (values.extension.length > 100) {
      errors.extension = "Extension cannot be more than 100 letters!";
      setValueTab(0);
    }

    return errors;
  };

  const onSubmitForm = async (values: IForm) => {
    const updatedValues = { ...values };
    if (validationDocumentType == DocumentType.toId(DocumentType.Softcopy)) {
      updatedValues.area = "-";
      updatedValues.address = "-";
    }
    setFormData(updatedValues);

    if (errorUpload == "" && !crrNumError) {
      setActionClick("submit");
      setOpenConfirmation(true);
    }
  };

  const handleSaveAsDraft = async (props) => {
    const formikErrors = validation(props.values);

    if (Object.keys(formikErrors).length === 0) {
      const updatedValues = { ...props.values };
      if (validationDocumentType == DocumentType.toId(DocumentType.Softcopy)) {
        updatedValues.area = "-";
        updatedValues.address = "-";
      }
      setFormData(updatedValues);

      if (errorUpload == "" && !crrNumError) {
        setActionClick("save");
        setOpenConfirmation(true);
      }
    } else {
      props.setErrors(formikErrors);
    }
  };

  const handleSaveOrSubmit = async () => {
    setOpenConfirmation(false);
    setLoadingActive(true);
    const newDataUpload = [...dataUpload];
    const valReqDate =
      requestStatusID == RequestStatus.toId(RequestStatus.Draft)
        ? initialValues.requestDate
        : requestDate;
    const dateChoosen = new Date(validationDateOfPower).setHours(0, 0, 0, 0);
    const dateToday = new Date(
      moment(valReqDate).format("YYYY-MM-DD")
    ).setHours(0, 0, 0, 0);
    if (dateChoosen >= dateToday) {
      // Clear data db if upload single file
      const newItem1 = {
        title: "Approval BU Leader / BU Leader Approval*",
        fileType: "Approval BU Leader",
        files: [
          { documentID: "", fileBase64: "", fileName: "", folderName: "" },
        ],
      };
      newDataUpload.push(newItem1);
      const newItem2 = {
        title: "Unggah Permohonan Partner / Upload Partner Request",
        fileType: "Partner Request",
        files: [
          { documentID: "", fileBase64: "", fileName: "", folderName: "" },
        ],
      };
      newDataUpload.push(newItem2);
    }

    if (actionClick == "submit") {
      const submit = await editForm(
        formData,
        newDataUpload,
        id,
        RequestStatus.toId(RequestStatus.RequestReceive),
        crrNumber
      );
      setLoadingActive(false);
      if (submit.resultCode === 200) {
        setRequestNumber(submit.data.requestNumber);
        setFeedbackText("Your data has been successfully saved!");
        setFeedbackType("success");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
          setOpenFeedbackNotification(true);
        }, 2000);
      } else {
        setFeedbackText(submit.errorMessage);
        setFeedbackType("failed");
        setOpenFeedback(true);
      }
    } else {
      const save = await editForm(
        formData,
        newDataUpload,
        id,
        RequestStatus.toId(RequestStatus.Draft),
        crrNumber
      );
      setLoadingActive(false);
      if (save.resultCode === 200) {
        setFeedbackText("Your data has been successfully saved!");
        setFeedbackType("success");
        setOpenFeedback(true);
        setTimeout(() => {
          Navigate("/");
        }, 3000);
      } else {
        setFeedbackText(save.errorMessage);
        setFeedbackType("failed");
        setOpenFeedback(true);
      }
    }
  };

  const onResetForm = async () => {
    setLoadingActive(true);
    if (id !== undefined) {
      await getSingleData();
    }
    setLoadingActive(false);
  };

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  const handleChangeUpload = async (data, dataIndex, fileIndex) => {
    if (data != undefined) {
      if (data.name.length > 150) {
        setFeedbackText("File name cannot be more than 150 letters!");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
        return;
      }
      const resultBase64File: any = await getBase64(data).then(
        (bs64: any) => bs64
      );

      const newDataUpload = [...dataUpload];
      const newFileNameWithoutDate = RemoveDateFromFileName(data.name);
      const filteredSameFileName = !newDataUpload.some((item) =>
        item.files.some((file) => {
          const existingFileNameWithoutDate = RemoveDateFromFileName(
            file.fileName
          );
          return existingFileNameWithoutDate === newFileNameWithoutDate;
        })
      );

      if (filteredSameFileName) {
        newDataUpload[dataIndex] = {
          title: newDataUpload[dataIndex].title,
          fileType: newDataUpload[dataIndex].fileType,
          files: [...newDataUpload[dataIndex].files],
        };
        newDataUpload[dataIndex].files[fileIndex] = {
          documentID: "",
          fileBase64: resultBase64File,
          fileName: data.name,
          folderName: "",
        };
        setDataUpload(newDataUpload);
        if (
          newDataUpload[dataIndex].title.includes("*") &&
          newDataUpload[dataIndex].files[fileIndex].fileBase64 != ""
        ) {
          setErrorUpload("");
        }
      } else {
        setFeedbackText("The file already exists, please change the file name");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
      }
    }
  };

  const handleChangeDelete = (dataIndex: number, fileIndex: number) => {
    const newDataUpload = [...dataUpload];
    newDataUpload[dataIndex].files[fileIndex] = {
      documentID: "",
      fileBase64: "",
      fileName: "",
      folderName: "",
    };
    setDataUpload(newDataUpload);
    if (
      newDataUpload[dataIndex].title.includes("*") &&
      newDataUpload[dataIndex].files[fileIndex].fileBase64 == ""
    ) {
      setErrorUpload("Please upload required file");
    }
  };

  const handleChangeDownload = async (dataIndex, fileIndex) => {
    const getDataUpload = [...dataUpload];
    const downloadLink = document.createElement("a");

    // eslint-disable-next-line unicorn/consistent-function-scoping, consistent-return
    const downloadFile = async () => {
      try {
        // get all data for table list User
        const currentTime: any = new Date();
        const differenceInMinutesTokenSharepoint: any =
          (sharepoint.expToken - currentTime) / 1000 / 60;

        if (differenceInMinutesTokenSharepoint < 10) {
          const tokenSharepoint = await getSharepointToken();
          setSharepoint({
            ...sharepoint,
            token: tokenSharepoint.token,
            expToken: new Date(currentTime.getTime() + 30 * 60 * 1000),
          });
          // lakukan download
          const getBase64Download = await downloadSingleFile(
            getDataUpload[dataIndex].files[fileIndex].fileName,
            getDataUpload[dataIndex].fileType,
            id,
            tokenSharepoint.token
          );
          return getBase64Download;
        }
        // eslint-disable-next-line no-else-return
        else {
          const getBase64Download = await downloadSingleFile(
            getDataUpload[dataIndex].files[fileIndex].fileName,
            getDataUpload[dataIndex].fileType,
            id,
            sharepoint.token
          );
          return getBase64Download;
        }
      } catch (error) {
        // Handle error if needed
        console.log("Error fetching data:", error);
      }
    };

    setLoadingActive(true);
    const tempBase64File = await downloadFile();
    setLoadingActive(false);
    if (getDataUpload[dataIndex].files[fileIndex].documentID != "") {
      getDataUpload[dataIndex].files[fileIndex].fileBase64 = tempBase64File;
    }

    if (getDataUpload[dataIndex].files[fileIndex].fileBase64 != "") {
      downloadLink.href = getDataUpload[dataIndex].files[fileIndex].fileBase64;
      downloadLink.download =
        getDataUpload[dataIndex].files[fileIndex].fileName;
      downloadLink.click();
    }
  };

  const handleChangeDownloadCommentFromCL = async (data, i) => {
    const getDataComment = [...dataComment];
    const downloadLink = document.createElement("a");

    // eslint-disable-next-line unicorn/consistent-function-scoping, consistent-return
    const downloadFile = async () => {
      try {
        // get all data for table list User
        const currentTime: any = new Date();
        const differenceInMinutesTokenSharepoint: any =
          (sharepoint.expToken - currentTime) / 1000 / 60;

        if (differenceInMinutesTokenSharepoint < 10) {
          const tokenSharepoint = await getSharepointToken();
          setSharepoint({
            ...sharepoint,
            token: tokenSharepoint.token,
            expToken: new Date(currentTime.getTime() + 30 * 60 * 1000),
          });
          // lakukan download
          const getBase64Download = await downloadFileComment(
            getDataComment[i].commentID,
            id,
            tokenSharepoint.token
          );
          return getBase64Download;
        }
        // eslint-disable-next-line no-else-return
        else {
          const getBase64Download = await downloadFileComment(
            getDataComment[i].commentID,
            id,
            sharepoint.token
          );
          return getBase64Download;
        }
      } catch (error) {
        // Handle error if needed
        console.log("Error fetching data:", error);
      }
    };

    setLoadingActive(true);
    const tempBase64File = await downloadFile();
    setLoadingActive(false);
    if (getDataComment[i].commentID != "") {
      getDataComment[i].fileBase64 = tempBase64File;
    }

    if (getDataComment[i].fileBase64 != "") {
      downloadLink.href = getDataComment[i].fileBase64;
      downloadLink.download = getDataComment[i].evidence;
      downloadLink.click();
    }
  };

  const handleChangeDateOfPower = (date) => {
    const dateChoosen = new Date(date).setHours(0, 0, 0, 0);
    const dateToday = new Date().setHours(0, 0, 0, 0);

    if (dateChoosen < dateToday && dataUpload.length == 1) {
      setDataUpload((prev) => [
        ...prev,
        {
          title: "Approval BU Leader / BU Leader Approval*",
          fileType: "Approval BU Leader",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        },
        {
          title: "Unggah Permohonan Partner / Upload Partner Request",
          fileType: "Partner Request",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        },
      ]);
    }

    if (dateChoosen >= dateToday && dataUpload.length > 1) {
      setDataUpload((prev) => [prev[0]]);
    }

    setErrorUpload("");
  };

  const handleOk = () => {
    Navigate("/");
  };

  const handleCRRChange = (value, error = "") => {
    setCrrNumber(value);
    setCrrError(error);
  };

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px", padding: 0, margin: 0 }}>
        <div className="tabs-container">
          Home {">"} {requestStatusName}
        </div>
        <div className="tabs-container">
          <hr style={{ color: "black", width: "100%" }} />
        </div>
      </Box>
      <Grid item lg={12} md={12} xs={12}>
        <div style={{ display: "flex" }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ marginLeft: "23px", width: "300px" }}
          >
            <b>
              No. Request / <i>Request Number</i>
            </b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "15px" }}
          >
            <b>:</b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "250px" }}
          >
            <b>{requestNumber}</b>
          </Typography>
        </div>
      </Grid>
      <Grid item lg={12} md={12} xs={12}>
        <div style={{ display: "flex" }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ marginLeft: "23px", width: "300px" }}
          >
            <b>
              Tanggal Permintaan / <i>Request Date</i>
            </b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "15px" }}
          >
            <b>:</b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "200px" }}
          >
            <b>
              {/* {requestStatusID == RequestStatus.toId(RequestStatus.Draft)
                ? initialValues.requestDate
                : requestDate} */}
              {initialValues.requestDate}
            </b>
          </Typography>
        </div>
      </Grid>
      <Grid item lg={12} md={12} xs={12}>
        <CRRNumberField
          crrNumber={crrNumber}
          crrNumError={crrNumError}
          onCRRChange={handleCRRChange}
        />
      </Grid>
      <div className="tabs-container" style={{ marginTop: "1.5%" }}>
        <Tabs value={valueTab} onChange={handleChangeTab} textColor="primary">
          <Tab
            style={{ color: valueTab === 0 ? "#fff" : "#000" }}
            color="primary"
            label="Data Diri / Profile"
            className={valueTab === 0 ? "active-tab-panel" : "hidden-tab-panel"}
          />

          <Tab
            style={{ color: valueTab === 1 ? "#fff" : "#000" }}
            color="primary"
            label="Permohonan Detil / Detail Request"
            className={valueTab === 1 ? "active-tab-panel" : "hidden-tab-panel"}
          />

          <Tab
            style={{ color: valueTab === 2 ? "#fff" : "#000" }}
            color="primary"
            label="Workflow"
            className={valueTab === 2 ? "active-tab-panel" : "hidden-tab-panel"}
          />
        </Tabs>
      </div>
      <div className="tabs-container">
        <hr className="tab-line" />
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmitForm}
        validate={validation}
        onReset={onResetForm}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit} onReset={props.handleReset}>
            <TabPanel value={valueTab} index={0}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Pemohon / <i>Applicant</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="binusianName"
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Jabatan / <i>Title</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent propsData={props} name="title" />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Divisi / <i>Business Unit</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="businessUnit"
                  />
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "25px" }}
                    gutterBottom
                  >
                    <u>Business Unit Leader</u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="buLeader"
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Department / <i>Department</i>
                    </u>
                  </Typography>
                  <TextFieldMultiDisabledComponent
                    propsData={props}
                    name="department"
                  />
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "40px" }}
                    gutterBottom
                  >
                    <u>
                      Ekstensi / <i>Extension</i> (Ext.)
                    </u>
                  </Typography>
                  <TextFieldComponent propsData={props} name="extension" />
                  {props.errors.extension && (
                    <div className="error-message">
                      {props.errors.extension}
                    </div>
                  )}
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  paddingTop: "20px",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(1)}
                >
                  Next Page {">>"}
                </Button>
              </Box>
            </TabPanel>
            <TabPanel value={valueTab} index={1}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Tanggal Surat Kuasa / <i>Date of Power of Attorney</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldDateValidationComponent
                    propsData={props}
                    name="dateOfPower"
                    onChildDataChange={(dataChild) =>
                      handleChangeDateOfPower(dataChild)
                    }
                  />
                  {props.errors.dateOfPower && (
                    <div className="error-message">
                      {props.errors.dateOfPower}
                    </div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Pihak Penandatangan / <i>Signer</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <AutocompleteComponent
                    propsData={props}
                    name="signer"
                    optional
                  />
                  {props.errors.signer && (
                    <div className="error-message">{props.errors.signer}</div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Judul Perjanjian / <i>Title of Agreement</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldMultiComponent
                    propsData={props}
                    name="titleAgreement"
                  />
                  {props.errors.titleAgreement && (
                    <div className="error-message">
                      {props.errors.titleAgreement}
                    </div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Partner / <i>Counterpart</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldComponent propsData={props} name="counterPart" />
                  {props.errors.counterPart && (
                    <div className="error-message">
                      {props.errors.counterPart}
                    </div>
                  )}
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "20px" }}
                    gutterBottom
                  >
                    <u>
                      Jenis Dokumen / <i>Document Type</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistComponentValidation
                    propsData={props}
                    onChildDataChange={(dataChild) =>
                      setValidationDocumentType(dataChild)
                    }
                    name="documentType"
                    ddlData={listDocumentType}
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {dataUpload.map((obj, i) => (
                    <div>
                      <UploadMultipleFileComponent
                        file={obj}
                        fileIndex={i}
                        onUploadFile={(data, fileIndex) => {
                          handleChangeUpload(data, i, fileIndex);
                        }}
                        onDeleteFile={(fileIndex) =>
                          handleChangeDelete(i, fileIndex)
                        }
                        onAddMoreData={() => {
                          if (dataUpload[i].files.length < 5) {
                            setDataUpload((prevState) => {
                              const newState = [...prevState];
                              const emptyFile = {
                                documentID: "",
                                fileBase64: "",
                                fileName: "",
                                folderName: "",
                              };
                              if (i >= 0 && i < newState.length) {
                                newState[i].files.push(emptyFile);
                              }

                              return newState;
                            });
                          }
                        }}
                        onDeleteData={(ind) => {
                          setDataUpload((prevState) => {
                            const newState = [...prevState];
                            if (
                              i >= 0 &&
                              i < newState.length &&
                              ind >= 0 &&
                              ind < newState[i].files.length
                            ) {
                              newState[i].files.splice(ind, 1);
                            }

                            return newState;
                          });
                        }}
                        onDownloadFile={(fileIndex) => {
                          handleChangeDownload(i, fileIndex);
                        }}
                        requiredValidationMessage={errorUpload}
                      />
                    </div>
                  ))}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {validationDocumentType ==
                    DocumentType.toId(DocumentType.Hardcopy) && (
                    <div style={{ paddingBottom: "20px" }}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Lokasi / <i>Area</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <DropdownlistComponent
                        propsData={props}
                        name="area"
                        ddlData={listAreaLocation}
                      />
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingTop: "20px" }}
                      >
                        <u>
                          Ruang / <i>Room</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <TextFieldMultiComponent
                        propsData={props}
                        name="address"
                      />
                      {props.errors.address && (
                        <div className="error-message">
                          {props.errors.address}
                        </div>
                      )}
                    </div>
                  )}
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Periode Penggunaan (Khusus Dokumen Master) /{" "}
                      <i>Period of Use (Master Document only)</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <Grid container spacing={3} item md={12} xs={12}>
                    <Grid item md={6} xs={6}>
                      <TextFieldDateComponent
                        propsData={props}
                        name="startDatePeriod"
                      />
                      {props.errors.startDatePeriod && (
                        <div className="error-message">
                          {props.errors.startDatePeriod}
                        </div>
                      )}
                    </Grid>
                    <Grid item md={6} xs={6}>
                      <TextFieldDateComponent
                        propsData={props}
                        name="endDatePeriod"
                      />
                      {props.errors.endDatePeriod && (
                        <div className="error-message">
                          {props.errors.endDatePeriod}
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Jenis Permohonan / <i>Request Type</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistComponentValidation
                    propsData={props}
                    name="requestType"
                    onChildDataChange={(dataChild) =>
                      setValidationRequestType(dataChild)
                    }
                    ddlData={listRequestType}
                  />
                </Grid>
              </Grid>

              <Grid container justifyContent="center" sx={{ mt: 2 }}>
                {requestNumber == "-" && (
                  <Button
                    variant="outlined"
                    sx={{
                      m: 1,
                      width: "150px",
                      textTransform: "none",
                      fontWeight: "bold",
                    }}
                    onClick={() => handleSaveAsDraft(props)}
                  >
                    Save as Draft
                  </Button>
                )}
                <Button
                  variant="contained"
                  sx={{
                    m: 1,
                    width: "150px",
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  type="submit"
                >
                  Submit
                </Button>
                <Button
                  variant="outlined"
                  sx={{
                    m: 1,
                    width: "150px",
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  type="reset"
                >
                  Reset
                </Button>
              </Grid>

              {dataComment.length > 0 && (
                <>
                  <Box sx={{ fontSize: "25px", marginTop: "3%" }}>
                    Komentar / <i>Comments for Requestor</i>
                    <hr />
                  </Box>
                  {dataComment.map((obj, i) => (
                    <CommentDisabledComponent
                      allObj={obj}
                      key={obj.commentID}
                      onChildDownload={(dataChild) =>
                        handleChangeDownloadCommentFromCL(dataChild, i)
                      }
                    />
                  ))}
                </>
              )}

              <Box
                sx={{
                  display: "flex",
                  paddingTop: "20px",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(0)}
                >
                  {"<<"} Previous Page
                </Button>
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(2)}
                >
                  {">>"} Next Page
                </Button>
              </Box>

              <ConfirmationDialog
                open={openConfirmation}
                title="Confirmation"
                message="Are you sure you want to proceed ?"
                onConfirm={() => {
                  handleSaveOrSubmit();
                }}
                onCancel={() => {
                  setOpenConfirmation(false);
                }}
              />

              <FeedbackNotification
                open={openFeedbackNotification}
                title="Your Request Number:"
                message={requestNumber}
                onConfirm={() => {
                  handleOk();
                }}
              />
            </TabPanel>
            <TabPanel value={valueTab} index={2}>
              <TransactionHistoryModal />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  paddingTop: "20px",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(1)}
                >
                  {"<<"} Previous Page
                </Button>
              </Box>
            </TabPanel>
            <Loading open={loadingActive} />
            <Feedback
              open={openFeedback}
              message={feedbackText}
              feedbackType={feedbackType}
              onClose={() => {
                if (feedbackType == "failed") {
                  setOpenFeedback(false);
                }
              }}
            />
          </form>
        )}
      </Formik>
    </Container>

    // <Grid item lg={6} md={12} xs={12}>
    //                 <Typography variant="subtitle1" gutterBottom>
    //                   Komentar Legal / Comment from Legal
    //                 </Typography>
    //                 <TextFieldMultiDisabledComponent parentToChild="Komentarnya" />
    //                 <Typography variant="subtitle1" gutterBottom>
    //                   Bukti / Evidence
    //                 </Typography>
    //                 <DownloadFileComponent fileName="bukti.jpg" />
    //               </Grid>
    // <div>
    //   <h1>My Form</h1>
    //   <Formik
    //     initialValues={initialValues}
    //     onSubmit={onSubmitForm}
    //     validate={validation}
    //   >
    //     {(props) => (
    //       <form onSubmit={props.handleSubmit}>
    //         <TextFieldComponent propsData={props} name="name" />

    //         {/* <TextFieldComponent onChildDataChange={handleDataTextArea}/> */}
    //         {props.errors.name && (
    //           <div id="feedback">{props.errors.name}</div>
    //         )}

    //         <TextFieldComponent propsData={props} name="email" />
    //         {props.errors.email && (
    //           <div id="feedback">{props.errors.email}</div>
    //         )}

    //         <TextFieldDateComponent propsData={props} name="startDate" />
    //         {props.errors.startDate && (
    //           <div id="feedback">{props.errors.startDate}</div>
    //         )}

    //         <TextFieldDateComponent propsData={props} name="endDate" />
    //         {props.errors.endDate && (
    //           <div id="feedback">{props.errors.endDate}</div>
    //         )}

    //         <TextFieldComponent propsData={props} name="binusianName" />
    //         {props.errors.binusianName && (
    //           <div id="feedback">{props.errors.binusianName}</div>
    //         )}

    //         <button type="submit">Submit</button>
    //       </form>
    //     )}
    //   </Formik>
    // </div>

    // <Container>
    //   <DatePickerComponent onChildDataChange={handleDataFromChild}/>
    //   <TextFieldMultiComponent onChildDataChange={handleDataTextArea}/>
    //   <TextFieldMultiComponent onChildDataChange={handleDataTextArea2}/>
    //   <DropdownlistComponent/>
    //   {/* <TextAreaComponent onChildDataChange={handleDataTextArea}/> */}
    //   {/* <TextAreaComponent onChildDataChange={handleDataTextArea2}/> */}
    // </Container>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export default EditForm;
